
import {
  Component, Prop, Ref, Watch,
} from 'vue-property-decorator'
import ViewModel from '@/models/ViewModel'
import DataTable from '@/components/DataTable/index.vue'
import PublisherReconciliation from '@/models/PublisherReconciliation'
import { getModule } from 'vuex-module-decorators'
import SystemtModule from '@/store/SystemModule'
import util from '@/mixins/util'
import WebMessage from '@/models/WebMessage'
import SearchInput from '@/components/SearchInput/SearchInput.vue'
import IconAction from '@/components/IconAction/IconAction.vue'
import Widget from '@/components/Widget/Widget.vue'
import DropArea from '@/components/DropArea/DropArea.vue'
import PdfModal from '@/components/PdfPreview/PdfModal.vue'
import row_fields from '../fields/invoices-fields'

@Component({
  mixins: [util],
  components: {
    DataTable,
    Widget,
    SearchInput,
    IconAction,
    DropArea,
    PdfModal,
  },
})
class PublisherReconciliationInvoicesView extends ViewModel {
  @Ref() readonly dataTable!: DataTable

  @Prop()
  public billingMonth!: any

  @Prop()
  public publisherId!: any

  @Prop({ default: true })
  public uploadFile!: boolean

  // =====
  public reload_drop_down_area: boolean = false

  public records: number = 0

  public loading: boolean = false

  public ready: boolean = false

  public query: string[] = []

  public selected: string[] = []

  public fieldFilters: any = {
    ...(this.billingMonth ? { billing_month: this.billingMonth } : {}),
  }

  public query_settings: any = {
    user_fields: [
      {
        name: 'owner',
        key: 'user_id',
      },
    ],
  }

  public fields: Array<any> = []

  public sortBy: string = 'created_at'

  public sortDesc: boolean = false

  public open_pdf: boolean = false

  public pdf_url: string = ''

  @Watch('open_pdf')
  public onOpenPdfChange(newValue: boolean) {
    const footer = document.getElementById('publisher-recon-footer')
    if (footer) {
      footer.style.display = newValue ? 'none' : 'block'
    }
  }

  public fieldFiltersKeys!: (fieldFilters: any) => string[]

  // =====

  public get show_fields(): Array<any> {
    return this.fields.filter((f: any) => f.show)
  }

  // =====

  public mounted(): void {
    // if route is view:invoices nad contains reference then set filters source_name to reference
    this.fields = row_fields
    if (this.$route.query.view === 'invoices' && this.$route.query.reference) {
      this.fieldFilters.id = this.$route.query.reference
      this.fields = this.fields.map((field: any) => {
        if (field.key === 'id') {
          return { ...field, show: true }
        }
        return field
      })
    }
    this.loadFilters()
  }

  public statusVariant(status: string): string {
    switch (status) {
      case 'approved':
        return 'success'
      case 'pending':
        return 'warning'
      default:
        return 'secondary'
    }
  }

  public async rows(ctx: any): Promise<any> {
    this.loading = true

    try {
      const field_filters = this.fieldFiltersKeys(this.fieldFilters)

      this.syncFilters()

      const result = await PublisherReconciliation.getInvoices(
        { billingMonth: this.billingMonth, publisherId: this.publisherId },
        {
          page_size: ctx.perPage,
          page: ctx.currentPage,
          order_by: this.sortBy ? this.sortBy : 'created_at',
          order: ctx.sortDesc ? 'desc' : 'asc',
          query: [...ctx.filter, ...field_filters],
          mode: 'exclusive',
        },
      )
      this.records = result.records
      return result.data
    } catch (error) {
      console.error('Error loading invoices:', error)
    } finally {
      this.loading = false
    }
  }

  public syncFilters(): void {
    const system = getModule(SystemtModule)
    system.updateState({
      name: 'filters',
      type: 'publisher-reconciliation-invoices',
      data: { query: this.query, fieldFilters: this.fieldFilters },
    })
  }

  public loadFilters(): void {
    const system = getModule(SystemtModule)
    system.getFilter('publisher-reconciliation-invoices').then((filter: any) => {
      if (filter) {
        this.query = filter.query
        this.fieldFilters = filter.fieldFilters
      }
      this.ready = true
    })
  }

  public refresh(): void {
    this.dataTable.refresh()
  }

  public uploading_invoice: boolean = false

  public invoice_file: File | null = null

  public async downloadInvoice(invoice: any): Promise<void> {
    try {
      await PublisherReconciliation.downloadInvoiceById(invoice.id)
    } catch (error: any) {
      WebMessage.error('Failed to download invoice')
      // @no-console
      console.error('Error downloading invoice:', error)
    }
  }

  public parseSize(size: number): string {
    if (size < 1024) return `${size} B`
    if (size < 1024 * 1024) return `${(size / 1024).toFixed(2)} KB`
    if (size < 1024 * 1024 * 1024) return `${(size / (1024 * 1024)).toFixed(2)} MB`
    return `${(size / (1024 * 1024 * 1024)).toFixed(2)} GB`
  }

  public readPdf(invoice: any): void {
    this.pdf_url = invoice.id
    this.open_pdf = true
  }

  public downloadPreviewPdf(filePath: string): void {
    PublisherReconciliation.downloadInvoiceById(filePath).catch((error: any) => {
      WebMessage.error('Failed to download invoice PDF')
      // @no-console
      console.error('Error downloading invoice PDF:', error)
    })
  }

  public closePdfPreview(): void {
    this.open_pdf = false
    this.pdf_url = ''
  }

  public resetFilters(): void {
    this.query = []
    this.fieldFilters = {
      ...(this.billingMonth ? { billing_month: this.billingMonth } : {}),
    }
    this.syncFilters()
  }
}
export default PublisherReconciliationInvoicesView
